import React, { FC, JSX } from 'react';

interface MapContainerProps {
    children: string | JSX.Element;
}

export const MapContainer: FC<MapContainerProps> = ({ children }) => {
    return (
        <div className="d-flex" style={{ height: '100vh', width: '100vw' }} data-testid="map-container">
            {children}
        </div>
    );
};
